import React, {Component} from 'react';
import {Link}  from 'react-router-dom'
//import { Button }  from "../Button.js";
import "./Navbar.css";


class Navbar extends Component {
//	state = {clicked: false}
	
//	handleClick = () => {
//		this.setState({ clicked: !this.state.clicked}  )
//	}
	
	render() {
		return (
			<nav className="NavbarItems">
				<hl className="navbar-logo">(Hyper)Complex Seminar</hl>
				
				<ul className="nav-menu" >
					<li> <Link className='nav-links' to="/">Home</Link></li>				
					<li> <Link className='nav-links' to="/Committees">Committees</Link></li>										
					<li> <Link className='nav-links' to="/Publications">Publications and submissions</Link></li>	
				</ul>				
			</nav>
		)
	}
}

export default Navbar
